import React from 'react';
import { Sparkles } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
  showLogout?: boolean;
  onLogout?: () => void;
}

/**
 * LoadingScreen - Elegant auth checking screen with neural animation
 */
export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Đang tải...', 
  showLogout = false, 
  onLogout 
}) => {
  return (
    <div className="min-h-[100dvh] bg-[#020617] flex flex-col items-center justify-center p-6 text-white overflow-hidden relative">
      {/* Background Neural Elements */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-indigo-600/10 blur-[150px] rounded-full animate-pulse" />
      </div>

      <div className="relative z-10 text-center flex flex-col items-center">
        <div className="w-24 h-24 bg-white/5 border border-white/10 rounded-3xl backdrop-blur-3xl flex items-center justify-center mb-8 shadow-2xl animate-in zoom-in-50 duration-700">
          <Sparkles className="text-indigo-400 animate-pulse" size={40} />
        </div>
        <h1 className="text-4xl font-black text-white uppercase tracking-[0.4em] mb-4">F&B OS</h1>
        <div className="flex items-center gap-3 px-6 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-12">
           <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-ping" />
           <p className="text-xs font-black text-slate-400 uppercase tracking-[0.3em]">{message}</p>
        </div>

        {showLogout && onLogout && (
          <button
            onClick={onLogout}
            className="px-8 py-4 bg-white/5 hover:bg-white/10 text-white border border-white/20 rounded-2xl font-black uppercase tracking-[0.2em] text-[10px] transition-all backdrop-blur-md active:scale-95"
          >
            Terminate Sequence
          </button>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
